<template>
  <div>
    <div class="container mb-48">
      <AccountWidget />
      <div class="bg-gray rounded-t-md shadow relative z-50 mt-2 py-1 pb-4 sm:pb-8 rounded-b-md">
        <div class="text-center relative">
          <button
            class="absolute top-0 left-0 ml-6 mt-1 hover-animate"
            @click="$router.go(-1)"
          >
            <BackIcon />
          </button>
          <h2 class="mt-5 text-sm sm:text-2xl font-semibold uppercase text-primary">
            {{ $t('form.title') }}
          </h2>
          <h3 class="text-xs sm:text-base text-black-display mt-1 mb-6">
            {{ $t('form.fillIn') }}
          </h3>
        </div>
        <Form :key="id" />
      </div>
    </div>
  </div>
</template>
<script>
import AccountWidget from '@/components/AccountWidget';
import Form from '@/components/Form';
import BackIcon from '@/assets/icons/back.svg';
import { mapState } from 'vuex';

export default {
  name: 'ContactForm',
  components: {
    AccountWidget,
    BackIcon,
    Form,
  },
  computed: {
    ...mapState('order', ['id']),
  },
};
</script>
